// @flow
export const requiredText = "This field is mandatory"



// WEBPACK FOOTER //
// ./src/forms/validators/shared.js